import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Marco B.',
  location: 'Milano, Italia'
}, {
  name: 'Giulia R.',
  location: 'Roma, Italia'
}, {
  name: 'Luca F.',
  location: 'Bologna, Italia'
}, {
  name: 'Alessia M.',
  location: 'Torino, Italia'
}, {
  name: 'Davide C.',
  location: 'Firenze, Italia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPurchase = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6200);
    };
    const initialTimer = window.setTimeout(showPurchase, 3200);
    const interval = window.setInterval(showPurchase, 17500);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-318" data-mp="27frmqsfdlnku">
      <div className="purchase-pop pointer-events-auto relative w-full max-w-[300px] border-2 border-brand-gold bg-brand-forest px-3 py-2.5 pr-9 text-white shadow-[0_10px_26px_rgba(47,47,47,0.28)]" data-id="element-319" data-mp="1xowqqwcbv9m7">
        <button type="button" onClick={() => setVisible(false)} aria-label="Chiudi notifica acquisto" className="absolute right-2 top-2 text-white/65 transition hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-gold" data-id="element-320" data-mp="2qdkdyxgn092e">
          <XIcon className="h-4 w-4" data-id="element-321" data-mp="2ged2ygxdkqig" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-322" data-mp="2gh92uass9p9j">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-gold bg-brand-gold/15" data-id="element-323" data-mp="2cd19u1faln5i"><ShoppingBagIcon className="h-4 w-4 text-brand-gold" data-id="element-324" data-mp="151kfvjfj4q8q" /></span>
          <div className="leading-tight" data-id="element-325" data-mp="10xkykymfdneb">
            <p className="text-xs font-bold" data-id="element-326" data-mp="1110hkcj7zgl0">{currentPurchase.name}</p>
            <p className="text-[10px] text-white/75" data-id="element-327" data-mp="12gco06oswit1">da {currentPurchase.location}</p>
            <p className="mt-0.5 text-[10px] font-bold uppercase tracking-wide text-brand-gold" data-id="element-328" data-mp="17dl6y9hrwqvc">ha appena acquistato STRENGTH PRO™</p>
          </div>
        </div>
      </div>
    </aside>;
}